"use client";

import VideoHero from "@/components/videoHero";

interface HeroProps {
  title?: string;
  tagline?: string;
  video?: string;
  videoPortrait?: string;
  poster?: string;
  posterAlt?: string;
}

const Hero = ({ title, tagline, video, videoPortrait, poster, posterAlt }: HeroProps) => {
  return (
    <main>
      <VideoHero
        title={title}
        tagline={tagline}
        video={video}
        videoPortrait={videoPortrait}
        poster={poster}
        posterAlt={posterAlt}
      />
    </main>
  );
};

export default Hero;
